module.exports = __webpack_public_path__ + "static/media/implantoralsurgeryLogo.a8ea6a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/implantoralsurgeryLogo.png
// module id = 51
// module chunks = 0